"use client";

import DynamicForm from "@/components/DynamicForm";

export default function NewsletterForm() {
  return (
    <div className="col-span-1 order-4 min-h-[220px]">
      <DynamicForm formType="newsletter" />
    </div>
  );
}
